export default __webpack_public_path__ + "0fa44b9119c3a5489793c14e4c8bff38.png";